import { render, staticRenderFns } from "./GamesSearch.vue?vue&type=template&id=d08cb112&scoped=true&"
import script from "./GamesSearch.vue?vue&type=script&lang=js&"
export * from "./GamesSearch.vue?vue&type=script&lang=js&"
import style0 from "./GamesSearch.vue?vue&type=style&index=0&id=d08cb112&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08cb112",
  null
  
)

export default component.exports